import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import "./index.scss";
import Cookies from "universal-cookie";
import { ToastContainer, toast } from "react-toastify";
import { setAuthInfo } from "../../module/auth/auth.action";
import { CONFIG } from "../../config/constant";
import GoogleButton from "../../component/GoogleButton";
import AppleButton from "../../component/AppleButton";
import logo from "../../assets/images/logo.svg";


const Signup = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [commonError, setCommonError] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const regex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  const cookies = new Cookies();
  const navigate = useNavigate();

  useEffect(() => {
  }, [])

  function goToCreateAccount() {
    navigate("/login");
  }


  function isValidEmail() {
    if (!email) {
      setCommonError("Email required");
      return false;
    }
    if (!email.match(regex)) {
      setCommonError("Invalid Email");
      return false;
    }
    return true;
  }

  function isValidPassword() {
    if (!password) {
      setCommonError("Password required");
      return false;
    }
    return true;
  }

  async function Signup() {
    if (!isValidEmail()) {
      return;
    }
    if (!isValidPassword()) {
      return;
    }
    if (email && password) {
      const data = { email: email.toLowerCase(), password, firstname: firstName, lastname: lastName };
      const url = CONFIG.BASE_URL + "auth/register";
      let response = await fetch(url, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (response && response.status === 200) {
        let data = await response.json();
        props.setAuthInfo({
          email: data.email,
          token: data.token,
          role: data.role,
          userid: data._id,
          isLogin: true,
        });
        cookies.set("email", data.email, { path: "/" });
        cookies.set("token", data.token, { path: "/" });
        cookies.set("role", data.role, { path: "/" });
        cookies.set("userid", data._id, { path: "/" });
        cookies.set("isLogin", true, { path: "/" });
        setTimeout(() => {
          navigate("/home");
        }, 500);
      } else {
        response = await response.json();
        toast(response.message || response.error_message);
        setCommonError(response.message || response.error_message);
      }
    }
  }

  return (
    <Fragment>
      <div className="signup-page">
        <div className="content">
          <img src={logo} />
          <div className="content-section">
            <h2 className="title"> Sign Up To Start Watching</h2>
            {/* <GoogleButton text={"Sign up with Google"} />
            <AppleButton text={"Sign up with Apple"} />
            <div className="separator">
              <hr className="line"></hr>
              <span className="or">or</span>
              <hr className="line"></hr>
            </div> */}
            <form
              onSubmit={() => {
                return;
              }}
            >
              <div className="input-wrapper">
                <label className="label">First name</label>
                <input
                  type='text'
                  placeholder="First name"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value);
                  }}
                />
              </div>
              <div className="input-wrapper">
                <label className="label">Last name</label>
                <input
                  type='text'
                  placeholder="Last name"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value);
                  }}
                />
              </div>
              <div className="input-wrapper">
                <label className="label">Email</label>
                <input
                  type="text"
                  placeholder="Email *"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setCommonError("");
                  }}
                />
              </div>
              <div className="input-wrapper">
                <label className="label">Password</label>
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Password *"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setCommonError("");
                  }}
                />
                <span className={`eye-icon ${showPassword ? 'on' : 'off'}`} onClick={(e) => setShowPassword(!showPassword)}></span>
              </div>

              <div className="common-error">{commonError}</div>
              <input className="signup-btn" type="button" onClick={Signup} value="Sign Up" />
              <div className="create-account">
                Already have an account?
                <span onClick={goToCreateAccount}>Login</span>
              </div>
              <div className="privacy-terms">
                <span onClick={() => { window.open('https://watchcredo.com/privacy-policy/', "_blank"); }}>Privacy Policy</span>
                <span>|</span>
                <span onClick={() => { window.open('https://watchcredo.com/terms-of-service/', "_blank"); }}>Terms of use</span>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setAuthInfo,
    },
    dispatch
  );
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(Signup);
